
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.505.5c-.499 0-.658 1.949-.704 3.137l-.648.709a.112.112 0 00-.028.065l-.308 2.671L2.81 9.064a.116.116 0 00-.051.097v1.017a.117.117 0 00.079.112l3.678 1.244.261.825-1.258.639a.115.115 0 00-.065.103v.54a.115.115 0 00.093.112l1.715.359.131.317c.04.095.174.095.214 0l.131-.317 1.715-.359a.115.115 0 00.093-.112v-.54a.115.115 0 00-.065-.103l-1.258-.639.261-.825 3.678-1.244a.117.117 0 00.079-.112V9.161a.116.116 0 00-.051-.097L9.183 7.082l-.308-2.671a.112.112 0 00-.028-.065l-.648-.709C8.153 2.444 7.999.5 7.495.5h.01z"}})])
          )
        }
      }
    